import { UseCase } from "../../base";
import { MasterlocationRepository } from "../../repositories";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { LocationImportRequest } from "../../domain/requests/locations/location-import.request";
import { LocationImport } from "../../domain/models/location-import.model";

@Injectable({ providedIn: 'root' })
export class GetLocationImportUsecase implements UseCase<LocationImportRequest, LocationImport[]> {
  constructor(private readonly masterlocationRepository : MasterlocationRepository) {
  }

  execute(request: LocationImportRequest): Observable<LocationImport[]> {
    return this.masterlocationRepository.getLocationImport(request);
  }
}
